import "../../util/yup-locale";
import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { PromotionCtaForm } from "../../features/promotion-cta";

const element = document.querySelector<HTMLElement>("#promotion-cta");

if (element) {
  const promotionId = element.dataset.promotionId;
  const csrf = element.dataset.csrf;
  const srpUrl = element.dataset.srpUrl;
  const customerId = element.dataset.customerId;
  const businessId = element.dataset.businessId;
  if (promotionId && csrf) {
    const root = createRoot(element);
    root.render(
      <Sentry.ErrorBoundary
        fallback={
          <p>
            Der opstod en kritisk fejl. Genindlæs siden og prøv igen, eller
            kontakt support for hjælp.
          </p>
        }
      >
        <PromotionCtaForm
          promotionId={promotionId}
          csrf={csrf}
          srpUrl={srpUrl}
          customerId={customerId}
          businessId={businessId}
        />
      </Sentry.ErrorBoundary>
    );
  }
}
